export default __webpack_public_path__ + "static/media/background.60211608.jpg";